import React from "react";

// helpers
import { getLottieInfoProp } from "./helpers";

// utils
import { captureError, GenericError } from "@swiggy-private/core-ui";
import { NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";

interface IDineCashLottieRendererProps {
    lottieProps: ReturnType<typeof getLottieInfoProp>;
    rendererKey: string;
}

export async function DineCashLottieRenderer(): Promise<React.ComponentType | null> {
    try {
        const module = await import("@swiggy-private/dls-react-mxn/dist/WidgetController/widgets/LottieInfoLayoutCard");
        const { LottieInfoLayoutCard } = module as unknown as {
            LottieInfoLayoutCard: React.ComponentType<ReturnType<typeof getLottieInfoProp>>;
        };

        // `AsyncComponent` is typed as `ComponentType<{}>`; accept props loosely and narrow internally.
        const Renderer: React.FC = (props) => {
            const { lottieProps, rendererKey } = props as IDineCashLottieRendererProps;
            return <LottieInfoLayoutCard key={rendererKey} {...lottieProps} />;
        };

        return Renderer;
    } catch (err) {
        captureError(err);
        recordNREvent({
            eventType: NEWRELIC_TABLES.EMPTY_PAGE_RENDERED,
            page: "dine_cash_pooling",
            errorMessage: err instanceof Error ? err.message : "Unknown error",
        });
        return GenericError;
    }
}
